const LOAD_STATUS_CHANNEL = 'diamond-load-status-sync'

type LoadStatusMessage = {
  loadId: string
}

export function publishLoadStatusChanged(loadId: string) {
  if (typeof window === 'undefined' || typeof window.BroadcastChannel === 'undefined') return
  const channel = new window.BroadcastChannel(LOAD_STATUS_CHANNEL)
  channel.postMessage({ loadId } satisfies LoadStatusMessage)
  channel.close()
}

export function subscribeToLoadStatusChanges(loadId: string, onChange: () => void) {
  if (typeof window === 'undefined' || typeof window.BroadcastChannel === 'undefined') return () => {}
  const channel = new window.BroadcastChannel(LOAD_STATUS_CHANNEL)
  const handleMessage = (event: MessageEvent<LoadStatusMessage>) => {
    if (event.data?.loadId === loadId) onChange()
  }
  channel.addEventListener('message', handleMessage)
  return () => {
    channel.removeEventListener('message', handleMessage)
    channel.close()
  }
}
